import { ErrorWithCause, messageWithCauses, stackWithCauses } from 'pony-cause'

/**
 * This subclass of ErrorWithCause appends the cause's error message and stack to its own.
 * This allows simple error message handlers that do not support the cause property yet to
 * display the full stack. In the future, when datadog supports the cause property, we can simplify
 * this custom error class by removing the append code, so that each layer of the cause stack doesn't
 * have to include the full contents of the lower layers.
 *
 * Alternatives:
 * - Why not use the error-cause es-shim? I couldn't get Typescript to recognize its type, and we'd still have to
 * append the stack and cause manually until tooling catches up with support for the cause field.
 * - Why not node-verror? It uses large node dependencies since it's meant for node, which makes it too big (70KB)
 * to use on the frontend.
 *
 * @see https://github.com/tc39/proposal-error-cause
 * @see used for websocket, copied from https://github.com/freight-hub/frontend-infra/blob/ee75757d93c3e09a514a74a95d382a3f75826b49/libs/logger/src/CustomErrorWithCause.ts#L18
 * TODO: check if datadog has support for the cause property
 */
export class CustomErrorWithCause<T = undefined> extends ErrorWithCause<T> {
  constructor(message: string, options: { cause?: T } | undefined) {
    super(message, options)
    this.name = CustomErrorWithCause.name
    this.stack = stackWithCauses(this)
    this.message = messageWithCauses(this)
  }
}
